import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppLayout } from "@/components/layout/AppLayout";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import KnowledgeHub from "@/pages/kb/KnowledgeHub";
import KBCategory from "@/pages/kb/KBCategory";
import KBArticle from "@/pages/kb/KBArticle";
import Dashboard from "@/pages/Dashboard";
import Registry from "@/pages/Registry";
import NewInitiative from "@/pages/NewInitiative";
import InitiativeDetail from "@/pages/InitiativeDetail";
import AssessmentRun from "@/pages/AssessmentRun";
import Committee from "@/pages/Committee";
import ShadowAI from "@/pages/ShadowAI";
import Reevaluations from "@/pages/Reevaluations";
import ValueMonitoring from "@/pages/ValueMonitoring";
import Tasks from "@/pages/Tasks";
import Registries from "@/pages/Registries";
import Audit from "@/pages/Audit";
import Admin from "@/pages/Admin";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<Protected><AppLayout /></Protected>}>
            {/* Knowledge Hub — Homepage */}
            <Route path="/" element={<KnowledgeHub />} />
            <Route path="/kb/:categorySlug" element={<KBCategory />} />
            <Route path="/kb/article/:slug" element={<KBArticle />} />
            {/* Governance */}
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/registro" element={<Registry />} />
            <Route path="/registro/nueva" element={<NewInitiative />} />
            <Route path="/iniciativas/:id" element={<InitiativeDetail />} />
            <Route path="/iniciativas/:id/evaluar" element={<AssessmentRun />} />
            <Route path="/comite" element={<Committee />} />
            <Route path="/shadow-ai" element={<ShadowAI />} />
            <Route path="/reevaluaciones" element={<Reevaluations />} />
            <Route path="/valor" element={<ValueMonitoring />} />
            <Route path="/tareas" element={<Tasks />} />
            <Route path="/registros" element={<Registries />} />
            <Route path="/auditoria" element={<Audit />} />
            <Route path="/admin" element={<Admin />} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors closeButton />
    </AuthProvider>
  );
}

export default App;
